import { CSSObject } from "@emotion/react";

export const reactionContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
};
